module.exports = __webpack_public_path__ + "static/media/bg_login.28098719.jpg";